import { observer } from "mobx-react-lite";
import { Theme } from "../../../../../misc/Theme";
import { store } from "../../../../../stores/Store";
import { Enquiry } from "../../../../../models/Enquiry";
import React from "react";

interface EnquiryOutcomeDetailsProps {
    enquiry: Enquiry;
}

export default observer(function EnquiryOutcomeDetails ({enquiry}: EnquiryOutcomeDetailsProps) {

    if (store.NodeStore.leafNode?.uid?.includes("ENQUIRY")) {
        enquiry = store.NodeStore.leafNode
    }

    return (
        <div style={{height: "fit-content", overflowY: "auto"}}>
            {/* {enquiry.additionalOutcomeData?.data ? (
                <OutcomeData data={JSON.parse(enquiry.additionalOutcomeData.data)} />
            ) : null} */}

            <div style={{overflowX: "auto"}}>
                {enquiry.additionalOutcomeData?.salary_data?.rows?.length ? (
                    <SalaryTable salaryData={enquiry.additionalOutcomeData.salary_data} />
                ) : null}
            </div>

            {enquiry.additionalOutcomeData?.events ? (
                <StatusTrace eventsXml={enquiry.additionalOutcomeData.events} />
            ) : null}

            {enquiry.additionalOutcomeData?.evidence?.length ? (
                <EveidenceList evidenceList={enquiry.additionalOutcomeData?.evidence} />
            ) : null}
        </div>
    )
})

function EveidenceList ({evidenceList}) {
    return (
        <div>
            <h4>Documents required for Application</h4>

            <ul>
                {evidenceList.map((item, i) => <EvidenceItem evidence={item} key={i}  />)}
            </ul>
        </div>
    )
}

function EvidenceItem ({evidence}) { 
    return (
        <li>
            {evidence.label}

            <ul>
                {evidence.children?.map((childItem, ci) => (
                    <EvidenceItem key={ci} evidence={childItem} />
                ))}
            </ul>
        </li>
    )
}

function OutcomeData ({data}) {

    if (typeof data !== 'object') return <></>

    return (
        <div style={{fontSize: "12px"}} onClick={(e) => console.log(data)}>
            {!data.job_end_date ? (
                <p>The Job end date has been left open. {data.cos_duration}</p>
            ) : null}

            {data.job_end_date && data.cos_end_date && data.job_end_date !== data.cos_end_date ? (
                <div className="warning">
                    The CoS end date has been changed, it is not ...
                </div>
            ) : null}
            <p>{data.job_end_date}</p>
            <p>{data.cos_end_date}</p>
        </div>
    )
}

function StatusTrace ({eventsXml}) {

    var events = []
    var footnotes = []

    try {
        const parser = new DOMParser()

        eventsXml?.forEach((e) => {
            const xmlDoc = parser.parseFromString(e.replace("&", "and"), "text/xml")

            const footnoteElement = xmlDoc.getElementsByTagName("footnote")
            for (var i=0; i <= footnoteElement.length; i++) {
                if (footnoteElement[i]) {
                    footnotes.push(footnoteElement[i]?.textContent)
                    footnoteElement[i].textContent = `[${footnotes.length}]`
                }
            }

            const eventElement = xmlDoc.getElementsByTagName("event")
            for (var i=0; i <= eventElement.length; i++) {
                events.push(eventElement[i]?.innerHTML)
            }
        })
    } catch (e) {
        events = ["There was an error when processing the outcome details."]
    }

    return (
        <div>
            <div>
                {events.map((event, i) => (
                    <small key={i} dangerouslySetInnerHTML={{__html: event?.replace(/[\n\r\t]{2,}/gm, "\n\n")}}></small>
                ))}
            </div>

            <ol style={{fontSize: "12px", color: "grey"}}>
                {footnotes.map((fn, i) => (
                    <li key={i}>{fn}</li>
                ))}
            </ol>
        </div>
    )
}

function SalaryTable ({salaryData}) {

    var columnWidths = "70px 200px 90px 160px 130px"

    return (
        <div style={{width: "100%", minWidth: "fit-content", display: "grid", background: "#00000017", padding: "5px", gap: "7px", gridTemplateColumns: columnWidths}}>
            <span><b>Option</b></span>
            <span><b>Applicant Conditions</b></span>
            <span><b>Notes</b></span>
            <span><b>Minimum salary</b></span>
            <span><b>Outcome</b></span>

            {salaryData.rows.map((row, i) => (
                <React.Fragment key={i}>
                    <span>{row.option}</span>
                    <span>{row.conditions_desc}</span>
                    <span>{row.condition_refs}</span>
                    <span>{row.min_salary}</span>
                    <span style={{color: row.outcome ? Theme.palette.secondary.main : Theme.palette.error.main}}>
                        <b>{row.outcome ? "Contingent Pass" : "Fail"}</b>
                    </span>
                </React.Fragment>
            ))}
        </div>
    )
}